module.exports = __webpack_public_path__ + "static/media/kanyequote.c1b405cc.PNG";